import React, {Fragment, useEffect, useState} from "react"
import pdf from "../../../images/PDF.svg";
import {get, post} from "../../../effects/api/api.common";
import {
    PROGRESS_OVERVIEW_DETAIL_BY_APPLICATION_ID,
    PROGRESS_OVERVIEW_VALIDATE,
    PROGRESS_PERCENTAGE,
    PROGRESS_STAGES
} from "../../../constants/api";
import ConfirmationPopup from "./ConfirmationPopup";
import ConfirmationDialog from "../../common/controls/ConfirmationDialog";
import moment from "moment";

const ProgressOverviewFields = (props: any) => {

  const { statusId,evDate,isPrefer,flag} = props;
  const [isPref1,setIsPref1]=useState('');

    const [applicationId, setApplicationId] = useState('')
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false)
    const [progressStages, setProgressStages] = useState([])
    const [progressPercentage, setProgressPercentage] = useState([])
    const [activeIndex, setActiveIndex] = useState({arrow: true, index: 0})
    const [currentYear, setCurrentYear] = useState(new Date().getFullYear())
    const [year, setYear] = useState('')
    const [month, setMonth] = useState('')
    const [validateProgressId, setValidateProgressId] = useState(0)
    const [validateMessage, setValidateMessage] = useState({message: "", result: ""})
    const [showMessageModal,setShowMessageModal] = useState(false)
    const [isClickid, setIsClickid] = useState('');
    const [isevid, setEvid] = useState('');
    var currentdatenew = moment().format("YYYY-MM-DD")

    // //console.log('final props', props.applicationId)

    const getProgressByAppId = () => {
        const queryParam = (year ? '&year=' + year : '') + (month ? '&month=' + month : '')
        const apiUrl = `${PROGRESS_OVERVIEW_DETAIL_BY_APPLICATION_ID}${applicationId}&type=incubator${queryParam}`
        setLoading(true)
        get(apiUrl).then((response: any) => {
            if (!response || !response.data) return;
            setData(response.data.data)
        }).catch((err) => {
            //console.log('error', err)
            setData([])
        }).finally(() => {
            setLoading(false)
        })
    }

    useEffect(() => {
        getProgressByAppId()
        //console.log(props,"props")
//   const { meetingData,startup_application_id,applicationComments,statusId,evDate} = props;
setIsClickid(statusId)
setEvid(evDate)
setIsPref1(isPrefer)
    }, [applicationId, year, month,statusId,evDate,flag])

    const handleIconClick = (index: number) => {
        const iconState = activeIndex.arrow
        setActiveIndex({arrow: !iconState, index: index})
    }

    useEffect(() => {
        setApplicationId(props.applicationId)
        setIsClickid(statusId)
setEvid(evDate)
    }, [props.applicationId,statusId,evDate])


    useEffect(() => {
        const getProgressPercentage = () => {
            get(PROGRESS_PERCENTAGE).then((response: any) => {
                if (!response || !response.data) return;
                if (response?.data?.result === 'success') {
                    setProgressPercentage(response.data.data)
                } else {
                    setProgressPercentage([])
                }

            })
        }

        const getProgressStages = () => {
            get(PROGRESS_STAGES).then((response: any) => {
                if (!response || !response.data) return;
                if (response?.data?.result === 'success') {
                    setProgressStages(response.data.data)
                } else {
                    setProgressStages([])
                }
            })
        }

        getProgressPercentage()
        getProgressStages()


    }, [])


    const getStageNameById = (stageId: number) => {
        if (!stageId || !progressStages) return "NA"
        const filter = progressStages.find((key: any) => {
            return key.id === stageId
        })
        // @ts-ignore
        if (filter === undefined || Object.keys(filter).length === 0) return
        // @ts-ignore
        return filter.name ? filter.name : ''
    }
    const myNumberWithTwoDecimalPlace=(myNumber: string)=>{
        return  parseFloat(myNumber).toFixed(2);
     }
     
    const getStagePercentNameById = (percentId: number) => {
        if (!percentId || !progressPercentage) return "NA"
        const filter = progressPercentage.find((key: any) => {
            return key.id === percentId
        })
        // @ts-ignore
        if (filter === undefined || Object.keys(filter).length === 0) return
        // @ts-ignore
        return filter.name ? filter.name : ''
    }

    const handleValidateData = (progressId: number) => {
        setValidateMessage({result: "", message: ""})
        const formData = {
            id: progressId
        }
        post(PROGRESS_OVERVIEW_VALIDATE, formData).then((response: any) => {
            if (!response || !response.data) return;
            //console.log('validate', response.data)
            setValidateMessage(response.data)
            setShowMessageModal(true)

        })
    }

    return (
        <Fragment>


            <div className="row">
                <div className="col-md-6 mb-4">
                    <label className="col-form-head">
                        Choose year
                    </label>

                    <div className="select-custom">
                        <select
                            onChange={(e: any) => setYear(e.target.value)}
                            className="form-control input-height"
                            aria-label="Select Year"
                        >
                            <option value="">Please select Year</option>
                            {/* selected */}
                            <option value={currentYear}>{currentYear}</option>
                            <option value={currentYear - 1}>{currentYear - 1}</option>
                            <option value={currentYear - 2}>{currentYear - 2}</option>
                            <option value={currentYear - 3}>{currentYear - 3}</option>
                            <option value={currentYear - 4}>{currentYear - 4}</option>
                        </select>
                    </div>
                </div>
                <div className="col-md-6 mb-4">
                    <label className="col-form-head">
                        Choose Month
                    </label>

                    <div className="select-custom">
                        <select
                            onChange={(e: any) => setMonth(e.target.value)}
                            className="form-control input-height"
                            aria-label="Select Year"
                        >
                            <option value="">Please select Month</option>
                            {/* selected */}
                            <option value="1">January</option>
                            <option value="2">February</option>
                            <option value="3">March</option>
                            <option value="4">April</option>
                            <option value="5">May</option>
                            <option value="6">June</option>
                            <option value="7">July</option>
                            <option value="8">August</option>
                            <option value="9">September</option>
                            <option value="10">October</option>
                            <option value="11">November</option>
                            <option value="12">December</option>

                        </select>
                    </div>
                </div>
            </div>


            {!loading && data.length > 0 && data.map((key: any, index: number) => {
                // @ts-ignore
                return (
                    <Fragment key={index}>
                        {/*<div className="row">
                            <div id="q-1" className="reports-heading col-sm-10 left-align">
                            <span className="reports-heading ">
                                 {key.updated_at ? new Date(key.updated_at).toDateString() : new Date(key.created_at).toDateString()}
                            </span>
                            </div>
                            <div className="col-sm-1"/>
                            <div className="col-sm-1">
                                <div
                                    data-toggle="collapse"
                                    data-target={`#tranche-expand${index + 1}`}
                                    role="button"
                                    aria-expanded="false"
                                    aria-controls={`tranche-expand${index + 1}`}
                                    className="hide-icon pull-right hide-icon-details"
                                    id={`show-${index + 1}`}
                                >
                                    <img src={(activeIndex.index === index + 1 && activeIndex.arrow) ? Minus : Plus}
                                         className="img-fluid" alt="SISFS Logo"
                                         onClick={() => handleIconClick(index + 1)}/>
                                </div>
                            </div>

                        </div>*/}

                        <div className="accordion accordion-details-wrap" id="accordion-progress-details">
                            <div className="card accordion-card">
                                <div className={`card-header accordion-card-header ${index ? 'collapsed' : ''}`}
                                     data-toggle="collapse"
                                     data-target={`#progress_collapse_${index}`}
                                     aria-expanded={index === 0}>
                                    {key.for_month}
                                </div>

                                <div id={`progress_collapse_${index}`}
                                     className={`collapse ${index === 0 ? 'show' : ''}`}
                                     data-parent="#accordion-progress-details">
                                    <div className="card-body accordion-card-body">
                                        <div className="row">
                                            <div className="col-md-6 left-align mt-3">
                                                <p className="progressOverviewKey">Updated on</p>
                                                <p className="progressOverviewValue">
                                                    {key.data.updated_at ? new Date(key.data.updated_at).toLocaleDateString() : key.for_month}
                                                </p>
                                            </div>
                                            <div className="col-md-6 left-align mt-3">
                                                {/* <p className="progressOverviewKey">Validated by: Burn Industries</p> */}

                                                <p className="progressOverviewValue">{key.data.approve_date}</p>
                                            </div>

                                            <div className="col-md-6 left-align mt-3">
                                                <p className="progressOverviewKey">Stage</p>

                                                <p className="progressOverviewValue"> {getStageNameById(key.data.stage_id)}</p>
                                            </div>
                                            <div className="col-md-6 left-align mt-3">
                                                <p className="progressOverviewKey">Progress</p>

                                                <p className="progressOverviewValue"> {getStagePercentNameById(key.data.progress_in_percentage)}</p>
                                            </div>
                                            <div className="col-md-6 left-align mt-3">
                                                <p className="progressOverviewKey">Progress Description</p>
                                                <p className="progressOverviewValue mw80">
                                                    {key?.data?.progress_in_text}
                                                </p>
                                            </div>

                                            <div className="col-md-6 left-align mt-3">
                                                                <p className="progressOverviewKey">Jobs created by
                                                                    startup - till date</p>

                                                                <p className="progressOverviewValue"> {key?.data?.people_employed_till_date}</p>
                                                            </div>
                                                            <div className="col-md-6 left-align mt-3">
                                                                <p className="progressOverviewKey">Jobs created by
                                                                    startup - Lastest Quarter</p>
                                                                    {/* Number.isInteger(value)?value:value.toFixed(2) */}
                                                                <p className="progressOverviewValue"> {key?.data?.people_employed_latest_quarter}</p>
                                                            </div>
                                                            <div className="col-md-6 left-align mt-3">
                                                                <p className="progressOverviewKey">TurnOver of
                                                                    startup - Till Date</p>

                                                                <p className="progressOverviewValue"> &#8377; {key?.data?.turnover_till_date ? (myNumberWithTwoDecimalPlace(key?.data?.turnover_till_date)):key?.data?.turnover_till_date}</p>
                                                            </div>
                                                            <div className="col-md-6 left-align mt-3">
                                                                <p className="progressOverviewKey">TurnOver of
                                                                    startup - Lastest Quarter</p>

                                                                <p className="progressOverviewValue"> &#8377; {key?.data?.turnover_latest_quarter?(myNumberWithTwoDecimalPlace(key?.data?.turnover_latest_quarter)):key?.data?.turnover_latest_quarter}</p>
                                                            </div>
                                                            <div className="col-md-6 left-align mt-3">
                                                                <p className="progressOverviewKey">
                                                                Cumulative Quantum of External Funding Raised by Startup (post-SISFS selection only) – till date
                                                                </p>

                                                                <p className="progressOverviewValue"> &#8377; {key?.data?.external_fund_raised_till_date?(myNumberWithTwoDecimalPlace(key?.data?.external_fund_raised_till_date)):key?.data?.external_fund_raised_till_date}</p>
                                                            </div>
                                                            <div className="col-md-6 left-align mt-3">
                                                                <p className="progressOverviewKey">
                                                                Cumulative Quantum of External Funding Raised by Startup (post-SSFS selection only) – in latest quarter
                                                                </p>

                                                                <p className="progressOverviewValue"> &#8377; {key?.data?.external_fund_raised_latest_quarter?(myNumberWithTwoDecimalPlace(key?.data?.external_fund_raised_latest_quarter)):key?.data?.external_fund_raised_latest_quarter}</p>
                                                            </div>
                                                            <div className="col-md-6 left-align mt-3">
                                                                <p className="progressOverviewKey">
                                                                Cumulative GST Filed by Startup – till date 
                                                                </p>

                                                                <p className="progressOverviewValue"> &#8377; {key?.data?.gst_filled_till_date?(myNumberWithTwoDecimalPlace(key?.data?.gst_filled_till_date)):key?.data?.gst_filled_till_date}</p>
                                                            </div>
                                                            <div className="col-md-6 left-align mt-3">
                                                                <p className="progressOverviewKey">
                                                                Cumulative GST Filed by Startup – Lastest Quarter 
                                                                </p>

                                                                <p className="progressOverviewValue"> &#8377; {key?.data?.gst_filled_latest_quarter?(myNumberWithTwoDecimalPlace(key?.data?.gst_filled_latest_quarter)):key?.data?.gst_filled_latest_quarter}</p>
                                                            </div>
                                                            <div className="col-md-6 left-align mt-3">
                                                                <p className="progressOverviewKey">
                                                                Cumulative No. of Products and Services by Startup – till date 
                                                                </p>

                                                                <p className="progressOverviewValue">  {key?.data?.no_products_on_gem_portal_till_date}</p>
                                                            </div>
                                                            <div className="col-md-6 left-align mt-3">
                                                                <p className="progressOverviewKey">
                                                                Cumulative No. of Products and Services by Startup – Lastest Quarter
                                                                </p>

                                                                <p className="progressOverviewValue">  {key?.data?.no_products_on_gem_portal_latest_quarter}</p>
                                                            </div>
                                                            <div className="col-md-6 left-align mt-3">
                                                                <p className="progressOverviewKey">
                                                                Cumulative No. of IP Registration Requests Filed by the Startup - Till Date
                                                                </p>

                                                                <p className="progressOverviewValue">  {key?.data?.no_ip_regstr_req_till_date}</p>
                                                            </div>
                                                            <div className="col-md-6 left-align mt-3">
                                                                <p className="progressOverviewKey">
                                                                Cumulative No. of IP Registration Requests Filed by the Startup –  Latest quarter (₹)
                                                                </p>

                                                                <p className="progressOverviewValue">  {key?.data?.no_ip_regstr_req_latest_quarter}</p>
                                                            </div>

                                  
                                            <div className="col-md-6 left-align mt-3">
                                                <p className="progressOverviewKey">If any other</p>
                                                <p className="progressOverviewValue mw80">
                                                    {key?.data?.other_comment}
                                                </p>
                                            </div>

                                            {key.file_with_location &&
                                            <div className="col-md-6 left-align mt-3">
                                                <p className="eac-review-subtitle">Supporting Documents</p>

                                                <div className="row mt-2">
                                                    <div className="col-md-2">
                                                        <img src={pdf} alt="SISFS Logo"/>
                                                    </div>
                                                    <div className="col-md-10 left-align">
                                                        <p className="document-attched-label">Progressfieldtrials-No.422copy2final.pdf</p>
                                                    </div>

                                                </div>
                                            </div>
                                            }


                                        </div>
                                    </div>
                                   {/* {//console.log(flag,"flagss")} */}
                                    {((!key.data.approve_date)&&
                                    ((isevid < currentdatenew)&&(isClickid == '2' ||isClickid == '3' ||isClickid == '4'||isClickid == '5' ||(isClickid == '7' && isPref1 == '7' && flag == '1'))))?
                                    (<button className="tertiary text-center btn-yellow-primary mb-5"
                                                >
                                            VALIDATE DATA
                                        </button>)
                                    :(<div className="col-md-12 mb-4 clearfix text-center">
                                        <button className="tertiary text-center btn-yellow-primary mb-5"
                                                onClick={() => setValidateProgressId(key.data.id)}>
                                            VALIDATE DATA
                                        </button>
                                    </div>)}
                                    {/* } */}

                                </div>

                            </div>
                        </div>

                        <div className="application-incubator-hr">
                        </div>


                    </Fragment>
                )
            })
            }

            {!loading && data.length === 0 &&
            <h3 className="text-center pt-5 pb-5">
                No Data Found
            </h3>
            }

            {loading &&
            <h3 className="text-center pt-5 pb-5">
                Please wait...
            </h3>
            }


            {!!validateProgressId && !showMessageModal &&
            <ConfirmationPopup headerText="Are you sure you want to Validate?"
                               bodyText="Note: User cannot edit data once Validated."
                               message={validateMessage}
                               onDialogClose={() => {
                                   setValidateProgressId(0);
                               }}
                               onSuccess={() => handleValidateData(validateProgressId)}/>
            }


            {showMessageModal && !validateMessage.result && validateMessage.message &&
            <ConfirmationDialog
                headerText={"Failed"}
                bodyText={validateMessage.message}
                onDialogClose={() => window.location.reload()}
                iconClass="test"
            />
            }

            {showMessageModal && validateMessage.result && validateMessage.message &&
            <ConfirmationDialog
                headerText="Success"
                bodyText={validateMessage.message}
                onDialogClose={() => window.location.reload()}
            />
            }


        </Fragment>

    )
}

export default ProgressOverviewFields
